<template>
    <div class="select-wrap" :class="[{ active: !folded }, typeCls]" @click="toggle">
      <div class="select-label">
        {{valueObj.name}}
        <i class="select-caret el-icon-caret-bottom" :class="{rotate: !folded}"></i>
      </div>
      <ul class='select-options' v-if="!folded">
        <li :key="i" v-for="(opt, i) in options" @click="change(opt)">{{opt.name}}</li>
      </ul>
    </div>
</template>

<script>
export default {
  props: ['value', 'data', 'watchable', 'type'],
  data() {
    return {
      height: 0,
      folded: true
    };
  },
  computed: {
    valueObj() {
      return _.find(this.options, (opt) => opt.value === this.value) || {};
    },
    options() {
      return [...this.data];
    },
    typeCls() {
      return this.type || 'type01';
    }
  },
  created() {
  },
  methods: {
    toggle() {
      this.folded = !this.folded;
    },
    change({name, value}) {
      this.$emit('change', value);
    }
  },
}
</script>
